import React from "react";
import { Link } from "react-router-dom";
import { Card, Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import WorkIcon from "@mui/icons-material/Work";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import IndexCardHeader from "./IndexCardHeader";
import IndexCardPriceRow from "./IndexCardPriceRow";
import IndexCardInfoRow from "./IndexCardInfoRow";
import IndexCardSkillRow from "./IndexCardSkillRow";
import IndexCardFooter from "./IndexCardFooter";
import { getTypeColor } from "../../../../constants/colors";

const IndexCard = ({
  item,
  type,
  onMarkedRead,
  contractExists,
  isActive,
  component: Component = Link,
  to,
  ...props
}) => {
  // 掲載終了日を当日いっぱいに調整
  const publishEnd = new Date(item.publish_end_date);
  publishEnd.setHours(23, 59, 59, 999);

  // 未読の場合、NEW
  const isNew = !item.read_flag;

  // job/project 用の共通設定
  const color = getTypeColor(type);

  const handleClick = () => {
    onMarkedRead?.(item.id);
  };

  const workStyleLabel = {
    on_site: "常駐",
    remote: "フルリモート",
    hybrid: "ハイブリッド",
  }[item.work_style];

  return (
    <Card
      component={Component}
      to={to}
      onClick={handleClick}
      sx={{
        py: 1,
        px: 1.5,
        borderRadius: 4,
        border: "1px solid",
        borderColor: isNew ? color : alpha(color, 0.15),
        backgroundColor: isNew ? "#fff" : "#F9FAFF",
        boxShadow: 1,
        textDecoration: "none",
        color: "inherit",
        cursor: "pointer",
        "&:hover": { opacity: 0.8 },
      }}
      {...props}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.3,
        }}
      >
        {/* タイトル */}
        <IndexCardHeader
          title={item.title}
          isNew={isNew}
          itemId={item.id}
          type={type}
          contractExists={contractExists}
          isActive={isActive}
        />

        {/* 年収/単価 */}
        <IndexCardPriceRow
          type={type}
          isNew={isNew}
          priceMin={item.price_min}
          priceMax={item.price_max}
        />

        {/* 稼働形態 */}
        {workStyleLabel && (
          <IndexCardInfoRow
            type={type}
            isNew={isNew}
            icon={WorkIcon}
            text={workStyleLabel}
          />
        )}

        {/* 勤務地：プロジェクトは常駐/ハイブリッドのみ、求人は常に表示 */}
        {(type === "job" ||
          item.work_style === "hybrid" ||
          item.work_style === "on_site") && (
          <IndexCardInfoRow
            type={type}
            isNew={isNew}
            icon={LocationOnIcon}
            text={item.prefecture_names.join("・")}
          />
        )}

        {/* スキル */}
        <IndexCardSkillRow type={type} skills={item.skills} isNew={isNew} />

        {/* 掲載期限 */}
        <IndexCardFooter publishEndDate={item.publish_end_date} />
      </Box>
    </Card>
  );
};

export default IndexCard;
